import Dispatcher from '../dispatcher';
import Router from '../../routes';

export default {
  viewDetails(code) {
    Router.setRoute(`/transactions/refunds/${code}`);
  },

  requestRefund(details){
    Dispatcher.emit(Dispatcher.TRANSACTION_REQUEST_REFUND, details);
  },

  showRefundRestrictions(transId){
    Router.setRoute(`/transactions/${transId}/refund-restrictions`);
  },

  popRequestForm(transId, id){
    Router.setRoute(`/transactions/${transId}/request-refund/${id}`);
  }
};
